module.exports = __webpack_public_path__ + "static/media/kitty-confused.be419fe5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/kitty-confused.svg
// module id = 195
// module chunks = 0